<template>
  <div>
    <div class="mt-4 flex items-center space-x-4">
      <svg
        class="ml-2 w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <!-- eslint-disable max-len -->
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
        ></path>
        <!-- eslint-enable max-len -->
      </svg>
      <a class="cursor-pointer" @click.prevent="handleShow()">
        TBC Calculator <m-badge
        type="GREEN"
      >
        Updated
      </m-badge>
      </a>
    </div>
    <portal to="modals" v-if="show">
      <m-modal
        :show="show"
        @close="handleClose"
        isSidebar
        sidebarHeaderText="Transfer Balance Cap Calculator"
      >
        <div class="w-full">
          <transfer-balance-cap-container isModal />
          <div class="mt-4 flex justify-end">
            <m-button @click="handleClose">Close</m-button>
          </div>
        </div>
      </m-modal>
    </portal>
  </div>
</template>

<script>
import TransferBalanceCapContainer from '@/app/modules/wizard/modules/transfer-balance-cap/containers/transfer-balance-cap-container/transfer-balance-cap-container.vue';

export default {
  name: 'tbc-calculator-link',
  components: {
    TransferBalanceCapContainer,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    handleShow() {
      this.show = true;
      this.$mixpanel.track('tbc-init', {
        location: 'Nav Menu',
      });
    },
    handleClose() {
      this.show = false;
    },
  },
};
</script>

<style></style>
